export default {
  // Navigation
  'nav.timer': 'Timer',
  'nav.stopwatch': 'Stopwatch',
  'nav.worldclock': 'Jam Dunia',
  'nav.timestamp': 'Timestamp',
  'nav.home': 'Beranda',

  // Common buttons and actions
  'button.start': 'Mulai',
  'button.pause': 'Jeda',
  'button.stop': 'Berhenti',
  'button.reset': 'Atur Ulang',
  'button.ok': 'OK',
  'button.cancel': 'Batal',
  'button.close': 'Tutup',
  'button.save': 'Simpan',
  'button.delete': 'Hapus',
  'button.edit': 'Edit',
  'button.back': 'Kembali',
  'button.next': 'Selanjutnya',
  'button.previous': 'Sebelumnya',
  'button.submit': 'Kirim',
  'button.confirm': 'Konfirmasi',
  'button.convert': 'Konversi',
  'button.copy': 'Salin',
  'button.copied': 'Tersalin!',
  'button.now': 'Sekarang',
  'button.clear': 'Hapus',

  // Common labels
  'label.hours': 'Jam',
  'label.minutes': 'Menit',
  'label.seconds': 'Detik',
  'label.milliseconds': 'Milidetik',
  'label.minute': 'Menit',
  'label.second': 'Detik',
  'label.sound': 'Suara',
  'label.soundAlert': 'Suara',
  'label.fullscreen': 'Layar Penuh',
  'label.language': 'Bahasa',
  'label.selectLanguage': 'Pilih Bahasa',
  'label.languageSelectorInfo': 'Saat ini mendukung {{count}} bahasa. Pilih bahasa pilihan Anda dari opsi di atas.',

  // Common messages
  'message.timerComplete': 'Timer Selesai!',
  'message.timerCompleteDesc': 'Timer Anda telah selesai',
  'message.timerCompleteBody': 'Timer hitung mundur Anda telah selesai!',
  'message.stopwatchStarted': 'Stopwatch Dimulai',
  'message.stopwatchStartedDesc': 'Waktu stopwatch telah dimulai',
  'message.stopwatchStopped': 'Stopwatch Berhenti',
  'message.stopwatchStoppedDesc': 'Waktu stopwatch telah dijeda',
  'message.stopwatchReset': 'Stopwatch Diatur Ulang',
  'message.stopwatchResetDesc': 'Stopwatch telah diatur ulang ke nol',
  'message.notificationPermission': 'Izinkan notifikasi untuk mendapatkan pemberitahuan saat timer selesai',
  'message.clickToEdit': 'Klik angka waktu untuk mengedit waktu secara langsung',
  'message.addHours': '+ Tambah Jam',
  'message.escToExit': 'Tekan ESC untuk keluar dari layar penuh',
  'message.timeRemaining': '{{minutes}} menit {{seconds}} detik tersisa',
  'message.minutesRemaining': '{{minutes}} menit tersisa',
  'message.secondsRemaining': '{{seconds}} detik tersisa',
  'message.stopwatchTimeElapsed': '{{minutes}} menit {{seconds}} detik berlalu',
  'message.stopwatchMinutesElapsed': '{{minutes}} menit berlalu',
  'message.stopwatchSecondsElapsed': '{{seconds}} detik berlalu',
  'message.invalidTimestamp': 'Timestamp tidak valid',
  'message.invalidDateTime': 'Tanggal waktu tidak valid',
  'message.conversionError': 'Kesalahan konversi',

  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'Sekarang',
  'time.today': 'Hari Ini',
  'time.yesterday': 'Kemarin',
  'time.tomorrow': 'Besok',

  // Common errors
  'error.pageNotFound': 'Halaman Tidak Ditemukan',
  'error.somethingWrong': 'Terjadi kesalahan',
  'error.tryAgain': 'Silakan coba lagi nanti',

  // Footer
  'footer.about': 'Tentang timer.today',
  'footer.aboutDesc': 'timer.today adalah platform alat pengatur waktu online profesional yang menyediakan tiga fitur utama:',
  'footer.timerDesc': 'Alat hitung mundur yang dapat disesuaikan dengan pengaturan menit dan jam, sempurna untuk fokus kerja, waktu memasak, manajemen belajar, dan lainnya. Dilengkapi dengan peringatan suara dan notifikasi desktop.',
  'footer.stopwatchDesc': 'Alat pengatur waktu presisi tinggi dengan akurasi milidetik, cocok untuk latihan olahraga, operasi memasak, latihan ujian, dan skenario lain yang memerlukan waktu yang tepat.',
  'footer.worldClockDesc': 'Tampilan waktu real-time kota-kota besar di seluruh dunia dengan perhitungan zona waktu yang cerdas, memfasilitasi komunikasi bisnis internasional dan kolaborasi lintas zona waktu.',
  'footer.timestampDesc': 'Konverter timestamp Unix yang mendukung konversi dua arah antara timestamp dan datetime, dengan dukungan format detik dan milidetik.',
  'footer.termsOfService': 'Ketentuan Layanan',
  'footer.privacy': 'Privasi',
  'footer.contactUs': 'Hubungi Kami',
  'footer.changeLanguage': 'ubah bahasa',
  'footer.moreLanguage': 'lebih banyak bahasa',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30d',
  'quick.add1min': '+1 Mnt',
  'quick.add5min': '+5 Mnt',
  'quick.add10min': '+10 Mnt',
  'quick.add30min': '+30 Mnt',

  // Breadcrumb
  'breadcrumb.minuteTimer': 'Timer {{minutes}} Menit',
  'breadcrumb.timer': 'Timer',
  'breadcrumb.stopwatch': 'Stopwatch',
  'breadcrumb.worldClock': 'Jam Dunia',
  'breadcrumb.termsOfService': 'Ketentuan Layanan',
};
